import { useMutation, useQuery } from '@tanstack/react-query';

import { readShigoAppConfig } from '../../../lib/config';
import { useShigoSession } from '../../../lib/useShigoSession';
import { createNetworkPerformanceClient } from './api';
import type { NetworkPerformanceRequest } from './model';

export const networkPerformanceQueryKey = ['reporting', 'network-performance'] as const;
export const networkPerformanceNetworksQueryKey = [
  ...networkPerformanceQueryKey,
  'networks',
] as const;

function useNetworkPerformanceClient() {
  const { session } = useShigoSession();
  const config = readShigoAppConfig();
  if (!session) throw new Error('Shigo session is required.');
  return createNetworkPerformanceClient({
    config: {
      apiBaseUrl: config.apiBaseUrl,
      reportingServiceUrl: config.reportingServiceUrl,
      networkId: config.networkId,
    },
    accessToken: session.accessToken,
  });
}

export function useNetworkPerformanceNetworksQuery() {
  const client = useNetworkPerformanceClient();
  return useQuery({
    queryKey: networkPerformanceNetworksQueryKey,
    queryFn: client.listNetworks,
    staleTime: 300_000,
  });
}

export function useNetworkPerformanceQuery(request: NetworkPerformanceRequest) {
  const client = useNetworkPerformanceClient();
  return useQuery({
    queryKey: [...networkPerformanceQueryKey, 'report', request],
    queryFn: () => client.run(request),
  });
}

export function useNetworkPerformanceExportMutation() {
  const client = useNetworkPerformanceClient();
  return useMutation({ mutationFn: client.exportCsv });
}
